import { z } from 'zod';

export const partsRequestQueueQuerySchema = z.object({
  view: z.enum(['grouped', 'flat']).default('grouped'),
  status: z.enum(['open', 'ordered', 'in_transit', 'received', 'cancelled', 'all']).default('open'),
  supplierId: z.string().uuid().optional(),
  minAgeDays: z.coerce.number().int().nonnegative().optional(),
  hasStock: z.enum(['true', 'false']).optional(),
  promisedFrom: z.string().optional(),
  promisedTo: z.string().optional(),
});

export const createPosFromPartsRequestsSchema = z.object({
  requestIds: z.array(z.string().uuid()).min(1).max(200),
  lineQuantities: z
    .array(
      z.object({
        inventoryItemId: z.string().uuid(),
        qty: z.number().int().positive(),
      }),
    )
    .default([]),
});

export const allocatePartsRequestsSchema = z.object({
  requestIds: z.array(z.string().uuid()).min(1).max(200),
});

export const cancelPartsRequestSchema = z.object({
  reason: z.string().min(1).max(500),
});

export type CreatePosFromPartsRequestsInput = z.infer<typeof createPosFromPartsRequestsSchema>;
export type AllocatePartsRequestsInput = z.infer<typeof allocatePartsRequestsSchema>;
